/**
 * Product Vue Component
 * ------------------------------------------------------------------------------
 * Template in sections/product.liquid
 * 
 */

import Vue from 'vue';
import axios from 'axios';
import Slick from 'vue-slick';
import {getUrlWithVariant} from '@shopify/theme-product-form'; 

import ReadMore from './read-more.vue';
import ImageZoom from './image-zoom.vue';
import Accordion from './accordion.vue';
import Collapsible from './collapsible.vue';

import {apiEndpoint} from './../util/integration';

function removeParameterFromUrl(name, url) {
    if (!url) url = window.location.href;
    var newUrl = url.split("?")[0],
        param,
        params_arr = [],
        queryString = (url.indexOf("?") !== -1) ? url.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === name) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length) {
            newUrl = newUrl + "?" + params_arr.join("&");
        }
    }
    window.history.replaceState({path: newUrl}, '', newUrl);
}

Vue.component('product', {
    components: {
        ReadMore,
        Slick,
        ImageZoom,
        Accordion,
        Collapsible
    },

    props: [
        'productHandle',
        'appAddToCart',
        'isProductPage'
    ],

    data() {
        return {
            isLoadingProduct: false,
            isLoadingSiblings: false,
            isSubmitting: false,
            isAddtocartConfirmationOpen: false,
            isGalleryZoomOpen: false,
            isSizeGuideOpen: false,
            product: null,
            options: [],
            currentVariant: null,
            siblings: [],
            sibling: null,

            mainSlickOptions: {
                slidesToShow: 1,
                focusOnSelect: true,
                arrows: false,
                asNavFor: '.gallery__nav',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            dots: true
                        }
                    }
                ]
            },

            navSlickOptions: {
                slidesToShow: 3,
                focusOnSelect: true,
                vertical: true,
                arrows: false,
                asNavFor: '.gallery__main'
            },

            zoomSlickOptions: {
                slidesToShow: 1,
                focusOnSelect: true
            }
        }
    },

    computed: {
        isOnSale() {
            return this.currentVariant && this.currentVariant.compare_at_price > this.currentVariant.price || !this.currentVariant && this.product && this.product.compare_at_price > this.product.price;
        }
    },

    created() {
        this.isLoadingProduct = true;

        axios.get(`/products/${this.productHandle}.js`).then((response) => {
            console.log('product', response.data);
            this.product = response.data;

            // if the URL has ?variant=[variant.id], select that variant
            let queryStringValues = new URLSearchParams(window.location.search);
            if (queryStringValues.has('variant')) {
                let variantFromQueryString = this.product.variants.find((variant) => {
                    return variant.id == queryStringValues.get('variant');
                });
                if (variantFromQueryString) this.currentVariant = variantFromQueryString;

            } else if (this.product.variants.length == 1) {
                this.currentVariant = this.product.variants[0];
            }

            if (this.currentVariant) {
                for (let i = 1; i <= this.product.options.length; i++) {
                    this.options.push(this.currentVariant['option' + i]);
                }

                this.updateVariant();
                
            } else {
                for (let i = 1; i <= this.product.options.length; i++) {
                    this.options.push('');
                }
            }

            axios.get(`${apiEndpoint}info/product/${this.product.id}/siblings?shop=${Shopify.shop}`).then((response) => {
                // console.log('siblings', response.data);
                if (Array.isArray(response.data)) {
                    this.siblings = response.data;
                    this.sibling = this.siblings.filter(p => p.handle == this.product.handle)[0];
                }
    
            }).catch((error) => {
                console.log('Error loading sibilings', error);
            });

        }).catch((error) => {
            console.log('Error loading product', error);

        }).finally(() => {
            this.isLoadingProduct = false;
        });
    },

    methods: {
        updateVariant() {
            let variant = this._findVariant();
            this._setVariant(variant);
        },

        handleAddToCart() {
            if (this.currentVariant) {
                this.isSubmitting = true;

                this.appAddToCart(this.currentVariant.id).then((response) => {
                    // console.log('success');
                    this.isSubmitting = false;
                    this.isAddtocartConfirmationOpen = true;

                }).catch((error) => {
                    console.log('error', error);
                    this.isSubmitting = false;
                    alert('Cannot reach the server at this time, please try again later.');
                });
            }
        },

        openGalleryZoom(index=0) {
            this.isGalleryZoomOpen = true;

            var checkSlider = setInterval(() => {
                if (this.$refs.zoom) {
                    clearInterval(checkSlider);
                    setTimeout(() => {
                        this.$refs.zoom.reSlick();
                        this.$refs.zoom.goTo(index);
                    }, 100);
                }
            }, 100);
      
            setTimeout(() => {
                clearInterval(checkSlider);
            }, 10000);
        },

        closeGalleryZoom() {
            this.$refs.zoom.destroy();
            this.isGalleryZoomOpen = false;
        },

        toggleSizeGuide() {
            this.isSizeGuideOpen = !this.isSizeGuideOpen;
        },

        goToSibling(path) {
            if (!this.sibling) return;

            // console.log(path + this.sibling.handle);
            window.location = path + this.sibling.handle;
        },

        _findVariant() {
            for (let i = 0; i < this.product.variants.length; i++) {
                // console.log('variant', this.product.variants[i]);

                if (this.product.variants[i].option1 && this.product.variants[i].option1 != this.options[0]) continue;
                if (this.product.variants[i].option2 && this.product.variants[i].option2 != this.options[1]) continue;
                if (this.product.variants[i].option3 && this.product.variants[i].option3 != this.options[2]) continue;

                // console.log('variant found', this.product.variants[i]);
                return this.product.variants[i];
            }

            return null;
        },

        _setVariant(variant) {
            if (!variant) {
                this.currentVariant = '';
                removeParameterFromUrl('variant');
                return;
            }

            this.currentVariant = variant;
            
            if (this.isProductPage) {
                if (variant.featured_image)
                    this.$refs.main.goTo(variant.featured_image.position - 1);

                let url = getUrlWithVariant(window.location.href, variant.id);
                window.history.replaceState({path: url}, '', url);
            }
        }
    }
});